import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/penilaian/esai-kasek',
    name: 'penilaian-esai',
    component: () => lazyLoadView(import('@views/instansi/penilaian/esai/Index')),
    meta: {
      title: 'Penilaian Esai Kepala Sekolah',
      jenis: 'kasek',
    },
  },

  {
    path: '/i/:id(\\d+)/penilaian/esai-pa',
    name: 'penilaian-esai-pa',
    component: () => lazyLoadView(import('@views/instansi/penilaian/esai/Index')),
    meta: {
      title: 'Penilaian Esai Fasilitator',
      jenis: 'instruktur',
    },
  },

  {
    path: '/i/:id(\\d+)/penilaian/microteaching-kasek',
    name: 'penilaian-microteaching-kasek',
    component: () => lazyLoadView(import('@views/instansi/penilaian/microteaching/List')),
    meta: {
      title: 'Simulasi Mengajar dan Wawancara',
      tipe: 'kasek',
      api: 'peserta',
    },
  },

  {
    path: '/i/:id(\\d+)/penilaian/microteaching-instruktur',
    name: 'penilaian-microteaching-instruktur',
    component: () => lazyLoadView(import('@views/instansi/penilaian/microteaching/List')),
    meta: {
      title: 'Simulasi Melatih dan Wawancara Fasilitator',
      tipe: 'instruktur',
      api: 'pelatih-ahli',
    },
  },
];
